import 'imports-loader?jQuery=jquery!typeahead.js';
import './css/style.css';
